import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { unassignConsistencyCheckRanTemplate } from '@api/consistencyCheck';

import { IId } from '@interfaces/common/common';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONSISTENCY_RAN_TABLE, CONSISTENCY_RAN_UNASSIGN_TEMPLATE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConsistencyCheckRanUnassignTemplate {
	unassignTemplate: UseMutateFunction<any, any, IId, any>;
	isLoadingUnassignTemplate: boolean;
}

export const useMutateConsistencyCheckRanUnassignTemplate = ({
	onSuccess,
}: IOnSuccess): IUseMutateConsistencyCheckRanUnassignTemplate => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IId>({
		mutationKey: [CONSISTENCY_RAN_UNASSIGN_TEMPLATE],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: unassignConsistencyCheckRanTemplate,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.unassignConsistencyCheckRanTemplate,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([CONSISTENCY_RAN_TABLE])];
		},
	});

	return {
		unassignTemplate: mutate,
		isLoadingUnassignTemplate: isLoading,
	};
};
